import {
  call,
  put,
  takeLeading,
  all,
  delay,
  select,
} from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import extractErrorMessage from 'utils/axios';
import { TOAST_TIMEOUT, showError } from 'shared/toaster';
import i18n from 'i18n';
import { doExtendSession, doExtendSessionRejected } from 'data/authentication/authentication.actions';
import {
  getNetworkTopologyFulfilled,
  loadMockDataFileFulfilled,
} from './network-topology.actions';
import * as api from './network-topology.api';
import {
  NetworkTopologyElementsEnum,
  MOCK_DATA_ENUM,
  GET_NETWORK_TOPOLOGY,
  GetNetworkTopologyAction,
} from './network-topology.types';
import { getAuthenticationCurrentPathname } from '../authentication/authentication.selectors';
import { getNetworkTopologyPollingTime } from '../../xcipio/discovery-xcipio-selectors';

const DEFAULT_POLLING_TIME = '900';

export function* getNetworkTopology(action: GetNetworkTopologyAction): Generator {
  const {
    deliveryFunctionId,
    shouldUseNetworkTopologyMockData,
    shouldUseNetworkTopologyDinamicLocations
  } = action.payload;
  const pollingTime = yield select(getNetworkTopologyPollingTime);
  const pollTime = !pollingTime || pollingTime === '' ? DEFAULT_POLLING_TIME : pollingTime;
  let loop = true;
  if (shouldUseNetworkTopologyMockData && !shouldUseNetworkTopologyDinamicLocations) {
    try {
      const mockFileResponse = yield call(api.getMockDataFile, MOCK_DATA_ENUM.MOCK_1000_AFS_1000_CFS_50_CCPAGS);
      yield put(loadMockDataFileFulfilled(mockFileResponse as AxiosResponse<ServerResponse<any>>))
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error);
      showError(i18n.t('networkTopology.mock.files.failed', { error: errorMessage }), TOAST_TIMEOUT);
    }
  } else {
    const response = yield call(api.getNetworkTopology, deliveryFunctionId);
    // TO-DO: do a diff check and call the below only if there is any diff else reject it
    yield put(getNetworkTopologyFulfilled(response as { element: NetworkTopologyElementsEnum; data: unknown[]; }[]));
  }
  while (loop) {
    try {
      const currentLocation = yield select(getAuthenticationCurrentPathname);
      const currentPathname = currentLocation as string;
      if (currentPathname !== '' && !currentPathname?.includes('topology')) {
       break;
      }
      yield put(doExtendSession());
    } catch (err: any) {
      yield put(doExtendSessionRejected(err));
    } finally {
      if (loop) {
        yield delay(+(pollTime as number) * 1000);
      }
    }
    // end loop

    if (process.env.NODE_ENV === 'test') {
      loop = false;
    }
  }
}

function* networkTopologySaga(): Generator {
  yield all([takeLeading(GET_NETWORK_TOPOLOGY, getNetworkTopology)]);
}

export default networkTopologySaga;
